/** R1c / #622 (PO 2026-10-30): manager labels come from profiles/configuration;
 * technical identifiers and provisioning labels are not a person's name.
 * This only recognises fixed technical codes, never guest free text.
 */
export function configuredDisplayName(value: unknown, technicalId?: string): string | null {
  const name = typeof value === 'string' ? value.trim() : '';
  return name && name !== technicalId ? name : null;
}

export function userDisplayName(user: { uid: string; role?: unknown }, ...sources: unknown[]): string | null {
  for (const source of sources) {
    const name = configuredDisplayName(source, user.uid);
    if (!name || (typeof user.role === 'string' && name.toLowerCase() === user.role.toLowerCase())) continue;
    if (/^Name unbekannt$/iu.test(name) || /(^R\d+\b|\bAD-\d+\b)/iu.test(name)) continue;
    return name;
  }
  return null;
}
